export type FormatKeyValues = {
  [countryCode: string]: {
    [siteName: string]: {
      mobile?: { [placementName: string]: string | string[]}
      desktop?: { [placementName: string]: string | string[]};
    };
  };
};

export const keyValues: FormatKeyValues = {
  "dk": {
    "familiejournal": {
      "mobile": {
        "top_ad": "topscroll_mob",
        "responsive_2": "interscroll_mob",
        "responsive_3": ["interscroll_mob", "double_interscroll_mob"],
        "responsive_4": "interscroll_mob",
        "responsive_5": ["interscroll_mob", "double_interscroll_mob"],
        "responsive_6": "interscroll_mob",
        "responsive_7": ["interscroll_mob", "double_interscroll_mob"],
        "responsive_8": "interscroll_mob",
        "responsive_9": ["interscroll_mob", "double_interscroll_mob"],
        "responsive_10": "interscroll_mob",
        "intext_ad_1": "interscroll_mob",
        "intext_ad_3": ["interscroll_mob", "double_interscroll_mob"],
        "intext_ad_4": "interscroll_mob",
        "intext_ad_5": ["interscroll_mob", "double_interscroll_mob"],
        "intext_ad_6": "interscroll_mob",
        "intext_ad_7": ["interscroll_mob", "double_interscroll_mob"],
        "intext_ad_8": "interscroll_mob",
        "intext_ad_9": ["interscroll_mob", "double_interscroll_mob"],
        "intext_ad_10": "interscroll_mob",
        "intext_ad_bottom": ["interscroll_mob", "double_interscroll_mob"]
      },
      "desktop": {
        "top_ad": "topscroll_dsk",
        "responsive_1": "skin",
        "responsive_3": ["interscroll_dsk", "double_interscroll_dsk"],
        "responsive_4": "interscroll_dsk",
        "responsive_5": ["interscroll_dsk", "double_interscroll_dsk"],
        "responsive_6": "interscroll_dsk",
        "responsive_7": ["interscroll_dsk", "double_interscroll_dsk"],
        "responsive_8": "interscroll_dsk",
        "responsive_9": ["interscroll_dsk", "double_interscroll_dsk"],
        "responsive_10": "interscroll_dsk",
        "intext_ad_1": "interscroll_dsk",
        "intext_ad_3": ["interscroll_dsk", "double_interscroll_dsk"],
        "intext_ad_4": "interscroll_dsk",
        "intext_ad_5": ["interscroll_dsk", "double_interscroll_dsk"],
        "intext_ad_6": "interscroll_dsk",
        "intext_ad_7": ["interscroll_dsk", "double_interscroll_dsk"],
        "intext_ad_8": "interscroll_dsk",
        "intext_ad_9": ["interscroll_dsk", "double_interscroll_dsk"],
        "intext_ad_10": "interscroll_dsk",
        "intext_ad_bottom": "interscroll_dsk"
      }
    }      
  }
}